//====================================================
//  Function: Update Products
//====================================================

var productTotalPrice;

var freshDataLayerData;
var freeShipping;
var freeShippingFormatted;

function componentUpdateProducts() {
  shoptet.scripts.setCustomCallback("shoptet.cart.updateCartButton", function (
    args
  ) {
    productTotalPrice = args[1];

    console.log("shoptet.cart.updateCartButton");

    if ($(".cart-price").length) {
      $(".cart-price").text(productTotalPrice);
    }

    if ($(".in-kosik").length) {
      $(".checkout-box-wrapper h4").html(questionBanner);
    }

    if ($(".cart-table .p-discount").length) {
      $(".cart-table tr.removeable").each(function () {
        var inst = $(this);
        inst.find(".p-name").prepend(inst.find(".p-discount"));
      });
    }
    setTimeout(() => {
      if ($("#cboxWrapper .advanced-order").length) {
        freshDataLayerData = dataLayer[0].shoptet;
        freeShipping = freshDataLayerData.cartInfo.leftToFreeShipping.priceLeft;
        freeShippingFormatted =
          freshDataLayerData.cartInfo.leftToFreeShipping.formattedPrice;

        componentProductModal();

        $("#cboxWrapper .advanced-order-suggestion").text(productSugTitle);

        $("#cboxWrapper .btn-conversion").text(productSugText);

        $("#cboxWrapper .extras-wrap").append(
          '<div class="extra step"><button class="btn btn--black-outline js-close-modal" rel="nofollow">' +
            productSugCon +
            "</button></div>"
        );

        calculateBasketFreeDelivery();

        $("#cboxWrapper .extra.step").insertBefore(
          $("#cboxWrapper .extras-wrap")
        );

        $("#cboxWrapper .extra.step").wrapAll(
          '<div class="extras-wrap extras-wrap--ext"></div>'
        );

        // $("#cboxWrapper .extra.delivery").addClass("extras-wrap");
      }
    }, 500);
  });

  // BASKET HEADER
  document.addEventListener("ShoptetDOMCartContentLoaded", function () {
    if (!$(".navigation-buttons .cart-count > i").length) {
      return false;
    }
    console.log("ShoptetDOMCartContentLoaded");
    if ($(window).width() < 768 && $(".cart-count").length) {
      window.location.href = "/kosik";
      return false;
    }

    freshDataLayerData = dataLayer[0].shoptet;
    freeShipping = freshDataLayerData.cartInfo.leftToFreeShipping.priceLeft;
    freeShippingFormatted =
      freshDataLayerData.cartInfo.leftToFreeShipping.formattedPrice;

    if ($(".cart-widget-inner .cart-widget-product-name").length > 0) {
      $(".user-action-cart").removeClass("is-empty");
    } else {
      $(".user-action-cart").addClass("is-empty");
    }

    if ($(".cart-free-shipping-block").length) {
      $(
        ".popup-widget.cart-widget .cart-free-shipping .cart-progress-bar div"
      ).remove();

      $(".cart-price").text(productTotalPrice);

      recalculateFreeDelivery();
    } else {
      // DELIVERY FREE
      $(".popup-widget.cart-widget .cart-free-shipping > div")
        .addClass("cart-free-shipping-text")
        .wrap('<div class="cart-free-shipping-block"></div>');

      var freeDeliverySvg =
        '<svg class="icon-svg icon-delivery"><use xlink:href="https://www.365121.myshoptet.' +
        lang +
        '/user/documents/public/images/sprites.svg#icon-delivery"></use></svg>';
      $(
        ".popup-widget.cart-widget .cart-free-shipping .cart-free-shipping-block"
      ).prepend(freeDeliverySvg);

      $(".popup-widget.cart-widget .cart-free-shipping").append(
        '<div class="cart-progress-bar"></div>'
      );

      $(".popup-widget.cart-widget .cart-free-shipping").insertAfter(
        ".popup-widget.cart-widget .cart-total"
      );

      $(".cart-price").text(productTotalPrice);

      recalculateFreeDelivery();
    }

    $(".cart-widget-product").each(function () {
      var inst = $(this);
      var amount = inst.find(".amount").val();
      var deleteElement = inst.find(".cart-widget-product-delete");
      var productHref = inst.find(".cart-widget-product-name a").attr("href");

      inst
        .find(".cart-widget-product-name a")
        .prepend("<small>" + amount + " x </small>");

      inst
        .find(".cart-widget-product-name strong")
        .after('<div class="cart-widget-product-info"></div>');

      inst
        .find(".cart-widget-product-info")
        .load(productHref + " .availability-label", function () {
          inst.find(".cart-widget-product-info").append(deleteElement);
        });
    });
  });

  // BASKET SUMMARY
  if ($(".in-kosik").length) {
    // FIRST
    freshDataLayerData = dataLayer[0].shoptet;
    freeShipping = freshDataLayerData.cartInfo.leftToFreeShipping.priceLeft;
    freeShippingFormatted =
      freshDataLayerData.cartInfo.leftToFreeShipping.formattedPrice;

    calculateBasketFreeDelivery();

    document.addEventListener("ShoptetDOMCartContentLoaded", function () {
      freshDataLayerData = dataLayer[0].shoptet;
      freeShipping = freshDataLayerData.cartInfo.leftToFreeShipping.priceLeft;
      freeShippingFormatted =
        freshDataLayerData.cartInfo.leftToFreeShipping.formattedPrice;

      calculateBasketFreeDelivery();

      componentBasket();
    });
  }
}

function recalculateFreeDelivery() {
  $(
    ".popup-widget.cart-widget .cart-free-shipping .cart-progress-bar"
  ).load(
    window.location.protocol +
      "//" +
      window.location.host +
      "/kosik .price-range",
    function () {}
  );

  if (freeShipping > 0) {
    var shippingText = freeDelText1 + freeShippingFormatted + " </strong> ";
  } else {
    var shippingText = "<strong> " + freeDelText2 + " </strong> ";
  }
  $(
    ".popup-widget.cart-widget .cart-free-shipping .cart-free-shipping-text"
  ).html(shippingText);
}

function calculateBasketFreeDelivery() {
  $(".extra.delivery").prepend('<div class="delivery-block-left"></div>');

  var freeDeliverySvg =
    '<svg class="icon-svg icon-delivery"><use xlink:href="https://www.365121.myshoptet.' +
    lang +
    '/user/documents/public/images/sprites.svg#icon-delivery"></use></svg>';
  $(".extra.delivery .delivery-block-left").prepend(freeDeliverySvg);
  $(".extra.delivery .delivery-block-left").append(freeDelText3);

  $(".extra.delivery > span").wrap('<div class="delivery-block-right"></div>');
  $(".extra.delivery .delivery-block-right").append($(".price-range"));

  if ($(".price-range").length > 1) {
    $(".price-range:nth-child(2)").remove();
  }

  if (freeShipping > 0) {
    var shippingText = freeDelText4 + freeShippingFormatted + " </strong> ";
  } else {
    var shippingText = "<strong> " + freeDelText2 + " </strong> ";

    $(".delivery-block-right").hide();

    $(".extra.delivery .delivery-block-left .delivery-block-title").html(
      "<span>" + freeDelText2 + "</span>"
    );
  }

  $(".extra.delivery .delivery-block-right span").html(shippingText);
}

$(document).on("click", ".js-close-modal", function () {
  $("#cboxClose").trigger("click");
});
